/**
 * @generated SignedSource<<fc85b654ed3950201ac1aac241bfac72>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type similarityPage_MergePreviewQuery$variables = {
  matchKind?: string | null | undefined;
  perspectiveId?: string | null | undefined;
  regex?: string | null | undefined;
  ruleIds: ReadonlyArray<string>;
};
export type similarityPage_MergePreviewQuery$data = {
  readonly ruleMergePreview: {
    readonly captured: ReadonlyArray<{
      readonly accountNumber: string | null | undefined;
      readonly amount: number;
      readonly description: string;
      readonly expenseNature: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly postingDate: string;
      readonly txn: {
        readonly id: string;
      };
    }>;
    readonly capturedCount: number;
    readonly coveringMatchKind: string | null | undefined;
    readonly coveringRegex: string | null | undefined;
    readonly droppedCount: number;
    readonly droppedManual: ReadonlyArray<{
      readonly accountNumber: string | null | undefined;
      readonly amount: number;
      readonly description: string;
      readonly expenseNature: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly postingDate: string;
      readonly txn: {
        readonly id: string;
      };
    }>;
    readonly droppedRuleAssigned: ReadonlyArray<{
      readonly accountNumber: string | null | undefined;
      readonly amount: number;
      readonly description: string;
      readonly expenseNature: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly postingDate: string;
      readonly txn: {
        readonly id: string;
      };
    }>;
    readonly manualConflictCount: number;
    readonly truncated: boolean;
  };
};
export type similarityPage_MergePreviewQuery = {
  response: similarityPage_MergePreviewQuery$data;
  variables: similarityPage_MergePreviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "matchKind"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perspectiveId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "regex"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ruleIds"
},
v4 = [
  {
    "kind": "Variable",
    "name": "matchKind",
    "variableName": "matchKind"
  },
  {
    "kind": "Variable",
    "name": "perspectiveId",
    "variableName": "perspectiveId"
  },
  {
    "kind": "Variable",
    "name": "regex",
    "variableName": "regex"
  },
  {
    "kind": "Variable",
    "name": "ruleIds",
    "variableName": "ruleIds"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coveringRegex",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coveringMatchKind",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "capturedCount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "droppedCount",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualConflictCount",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "truncated",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Txn",
  "kind": "LinkedField",
  "name": "txn",
  "plural": false,
  "selections": [
    (v11/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postingDate",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountNumber",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpenseNature",
  "kind": "LinkedField",
  "name": "expenseNature",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = [
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/)
],
v19 = [
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/),
  (v11/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "similarityPage_MergePreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "RuleMergePreview",
        "kind": "LinkedField",
        "name": "ruleMergePreview",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "captured",
            "plural": true,
            "selections": (v18/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "droppedRuleAssigned",
            "plural": true,
            "selections": (v18/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "droppedManual",
            "plural": true,
            "selections": (v18/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "similarityPage_MergePreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "RuleMergePreview",
        "kind": "LinkedField",
        "name": "ruleMergePreview",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "captured",
            "plural": true,
            "selections": (v19/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "droppedRuleAssigned",
            "plural": true,
            "selections": (v19/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "droppedManual",
            "plural": true,
            "selections": (v19/*: any*/),
            "storageKey": null
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1b5179863ba025965a9affe02dcd10d5",
    "id": null,
    "metadata": {},
    "name": "similarityPage_MergePreviewQuery",
    "operationKind": "query",
    "text": "query similarityPage_MergePreviewQuery(\n  $ruleIds: [ID!]!\n  $regex: String\n  $matchKind: String\n  $perspectiveId: ID\n) {\n  ruleMergePreview(ruleIds: $ruleIds, regex: $regex, matchKind: $matchKind, perspectiveId: $perspectiveId) {\n    coveringRegex\n    coveringMatchKind\n    capturedCount\n    droppedCount\n    manualConflictCount\n    truncated\n    captured {\n      txn {\n        id\n      }\n      postingDate\n      description\n      amount\n      accountNumber\n      expenseNature {\n        id\n        name\n      }\n      id\n    }\n    droppedRuleAssigned {\n      txn {\n        id\n      }\n      postingDate\n      description\n      amount\n      accountNumber\n      expenseNature {\n        id\n        name\n      }\n      id\n    }\n    droppedManual {\n      txn {\n        id\n      }\n      postingDate\n      description\n      amount\n      accountNumber\n      expenseNature {\n        id\n        name\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3b13217fcb48d9363dff2214d7873606";

export default node;
